// extracted by mini-css-extract-plugin
export default {"form":"contactform_form__cthkD","contacts":"contactform_contacts__iHgbk","input":"contactform_input__-I4Og","button":"contactform_button__RmsH3"};